export default "__VITE_ASSET__$LnWYZIl__"